<template>
    <div class="TTL-el-form-search-regular">
        <el-form inline="true">
            <el-form-item>
                <wcinput :option="{placeholder:'会员名称 / 会员电话',clearable:true,ischange:true,isinput:true,iskeydown:true}" 
                    :value="param.key"
                    @finish="(val)=> {
                        if(val.type=='input') {param.key=val.value;param.ischange=true;}
                        if(val.type=='change') {param.key=val.value;param.ischange=true;}
                        if(val.type=='keydown') GetMemberInfo();
                    }"
                />
            </el-form-item>
            <el-form-item>
                <wcbutton :option="{title:'搜索'}" @finish="GetMemberInfo()" />
            </el-form-item>
            <el-form-item>
                <wcbutton :option="{title:'新增会员'}" @finish="AddMember()" />
            </el-form-item>
        </el-form>
    </div>

    <div class="TTL-table top20" id="table-member-obj">
        <el-table :data="memberlist" stripe="true" empty-text="" ref="pet" @selection-change="selecttable">
            <template v-slot:empty><el-empty description="暂无数据" /></template>
            <el-table-column type="selection" />
            <el-table-column label="序号" type="index" min-width="50" align="center" />
            <el-table-column label="会员头像" align="center" v-if="pagelabel.avar">
                <template #default="scope">
                    <wcimage :value="scope.row.avar" :option="{size:'middle'}" />
                </template>
            </el-table-column>
            <el-table-column label="会员名称" prop="username" align="center" v-if="pagelabel.username">
                <template #default="scope">
                    <span class="ttl-membername">{{scope.row.username}}</span>
                </template>
            </el-table-column>  
            <el-table-column label="所属商家" prop="shopname" align="center" v-if="pagelabel.shopname"/>
            <el-table-column prop="phone" label="会员手机" align="center" v-if="pagelabel.phone"/>
            <el-table-column prop="inputtime" label="新增时间" align="center" v-if="pagelabel.inputtime"/>
            <!--
            <el-table-column label="操作" align="center">
                <template #default="scope">
                    <div class="TTL-btn-list">
                    <wcbutton :option="{title:'编辑'}" @finish="EditMember(scope.row.id)" />
                    <wcbutton :option="{title:'删除',type:'del'}" @finish="DeMember(scope.row.id)" class="left10" />
                    </div>
                </template>
            </el-table-column>
            -->
        </el-table>
    </div>
    <div class="TTL-page-box top20">
        <div class="TTL-page-box-in">
            <div class="TTL-select TTL-page-left">
                <el-select v-model="handlevalue" placeholder="请选择操作" clearable @change="changehandle">
                    <el-option v-for="(item,index) in handleinfos" :key="index" :label="item.name" :value="item.id" />
                </el-select>
            </div>
            <div class="TTL-page TTL-page-right">
                <wcpage 
                    :row="param.rows" 
                    :p="param.p" 
                    :rollpage="param.rollpage" 
                    @finish="(val)=> {
                        param.p=val.p;
                        param.rollpage=val.rollpage;
                        GetMemberInfo();
                    }"
                />
            </div>
        </div>
    </div>

    <!-- 页面标签 -->
    <Pagelabel :value="showpagelabel" :type="'member'" 
        @finish="(val)=> {
            showpagelabel=false;
            Getpagelabel(true);
        }" 
    />

</template>

<script>
import Pagelabel from '@/views/System/Pagelabel';
import INTERFACE_MODEL_MEMBER from '@/Interface/Member/Member';
export default {
    components:{
        Pagelabel
    },
    data() {
        return {
            showpagelabel:false,
            pagelabel:{},
            param: {
                phone:'',
                key:'',
                ischange:false,
                p:1,
                rollpage:10,
                rows:0,
            },
            memberlist:[],
            handlevalue:'',
            handleinfos:[
                {id:1,name:'批量删除会员'},
                {id:2,name:'批量修改会员'},
            ],

        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {


        /** 修改页面显示标签信息 **/
        ChangePageLabel() {
            this.showpagelabel=true;
        },



        /** 页面初始化 **/
        OnloadMethod() {
            this.Getpagelabel();      //获取页面显示标签信息
            this.GetMemberInfo();
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {          //组件已存在，同级兄弟元素调用时产生的操作
                this.GetMemberInfo();
            }else if(data.reload) {   //浏览器重新刷新时执行的操作
                this.GetMemberInfo();
            }else {
                this.GetMemberInfo();
            }
        },


        /** 新增会员信息 **/
        AddMember() {
            var navinfo={name:'新增会员',labelentry:'AddMember',components:'AddMember',isshow:false};
            var data={Method:''};
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },


        /** 删除会员信息 **/
        DeMember(id) {
            this.DelMemberData(id);
        },


        /** 删除会员信息操作 **/
        DelMemberData(ids) {
            INTERFACE_MODEL_MEMBER.DEL_MEMBER({ids:ids}).then((res) => {
                 if(res.status > 0) return false;
                 this.GetMemberInfo();
            });
        },


        /** 数据批操作处理 **/
        changehandle(index) {
            this.handlevalue='';
            var ids=this.GetSelectDataIds();
            if(ids.length == 0) {this.$notice({title:'消息提示',message:'请选择要批量执行的会员',type:'warning'});return false;}

            this.$confirm.confirm(
                '该操作将会批量修改数据，且不可恢复，是否执行 ？',
                '删除提示',
                {confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}
            ).then(()=> {
                if(index==1) {
                    this.DelMemberData(ids);
                }else if(index==2) {
                    this.EditMemberMore(ids);
                }
               
            }).catch(()=> {
                
            });
        },


        /** 编辑会员 **/
        EditMember(id) {
            this.EditMemberMore([id]);
        },


        /** 跳转至批量修改会员手机信息 **/
        EditMemberMore(ids) {
            var navinfo={name:'批量修改会员',labelentry:'EditMember',components:'EditMember',isshow:false};
            var data={Method:'',delcomponent:'',ids:ids.join(',')};
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },


        ///////////////////////////////////////////////////////
        //////////////////////////////////////////////////////
        //基础数据操作


        /** 表格数据选择 **/
        selecttable(val) {
            for(var i=0;i < this.memberlist.length;i++) this.memberlist[i].isshow=false;
            for(var i=0;i < val.length;i++) val[i].isshow=true;
            console.log(this.memberlist);
        },


        /** 获取会员信息 **/
        GetMemberInfo() {
            if(this.param.ischange) {
                this.param.p=1;
                this.param.ischange=false;
            }

            //loading等待动画加载
            var obj=document.getElementById("table-member-obj");
            this.$loading.openloading(obj);

            INTERFACE_MODEL_MEMBER.GET_MEMBER_INFO(this.param).then((res) => {
                 if(res.status > 0) return false;
                 this.$loading.closeloading(obj);
                 this.param.rows=res.data.count;
                 this.memberlist=res.data.list;
            });
        },


        /** 获取被勾选中的列表数据 **/
        GetSelectDataIds() {
            var ids=[];
            ids=this.memberlist.map((obj)=> obj.isshow ? obj.id : '');
            ids=ids.filter(element=> element!==null && element!==''); //数据进行去除空值处理
            return ids ? ids : [];
        },


        /** 获取列表显示 **/
        Getpagelabel(isfresh=false) {
            this.$method.GET_PAGE_LABEL_SETTING('member',isfresh).then((res) => {
                this.pagelabel=res ? res : {};
            });
        },

        //基础数据操作
        ///////////////////////////////////////////////////////
        //////////////////////////////////////////////////////


    },
}
</script>
<style scoped>
.TTL-select-infos {display:inline-flex;align-items: center;}
.TTL-select-infos span {margin-left:10px;}
.TTL-pet-image {position: relative;display: inline-block;}
.TTL-image-box-sex {width:20px;height: 20px;position:absolute;right:0;top:0;margin-right:-5px;margin-top:-5px;border-radius: 50%;background:#ffffff;}
.TTL-image-box-small {border-radius: 50%;}
.TTL-pet-box {display:inline-flex;align-items: center;width:100%;}
.TTL-pet-name {margin-left:20px;height: 60px;display: inline-flex;align-items:center;letter-spacing: 1px;line-height: 20px;color:#444444;}
.TTL-btn-list {display:inline-flex;}
.ttl-membername {color:#666eeb;}
</style>